import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { UiService } from 'src/app/services/ui.service'
import { ActivatedRoute } from '@angular/router'

@Component({
  selector: 'app-application-deleted-error',
  templateUrl: './application-deleted-error.component.html',
  styleUrls: ['./application-deleted-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ApplicationDeletedErrorComponent implements OnInit {
  accountId: string

  constructor(
    public uiService: UiService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.accountId = this.route.snapshot.paramMap.get('accountId')
  }
}
